export abstract class InputManagerBase {
    private _handler: (e: PointerEvent) => void | null = this.onPointerEvent.bind(this);
    private _started = false;
    private canvas: any;

    public init(dispatcher: any): this {
        this.canvas = dispatcher;
        return this;
    }

    public start(): void {
        if (this._started) {
            return;
        }
        this.canvas.addEventListener("pointerdown", this._handler);
        this.canvas.addEventListener("pointercancel", this._handler);
        this.canvas.addEventListener("pointerleave", this._handler);
        this._started = true;
    }
    private onPointerEvent(event: PointerEvent) {
        switch (event.type) {
            case "pointerdown":
                this.onStart(event);
                this.addListeners();
                break;
            case "pointermove":
                this.onDrag(event);
                break;
            case "pointerup":
                this.onDrag(event);
                this.onEnd(event);
            // eslint-disable-next-line no-fallthrough
            case "pointerleave":
            case "pointercancel":
                this.removeListeners();
                this.onCancel(event);
                break;
            case "pointerout":
                if (event.target === event.currentTarget) {
                    this.removeListeners();
                }
                break;
        }
    }

    protected abstract onStart(event: PointerEvent): void;
    protected abstract onEnd(event: PointerEvent): void;
    protected abstract onDrag(event: PointerEvent): void;
    protected onCancel(event: PointerEvent): void {}

    protected addListeners(): void {
        this.canvas.addEventListener("pointerup", this._handler);
        this.canvas.addEventListener("pointermove", this._handler);
        this.canvas.addEventListener("pointerout", this._handler);
    }
    protected removeListeners(): void {
        this.canvas.removeEventListener("pointerup", this._handler);
        this.canvas.removeEventListener("pointermove", this._handler);
        this.canvas.removeEventListener("pointerout", this._handler);
    }
    public stop() {
        this.canvas.removeEventListener("pointerdown", this._handler);
        this.canvas.removeEventListener("pointerup", this._handler);
        this.canvas.removeEventListener("pointermove", this._handler);
        this.canvas.removeEventListener("pointerout", this._handler);
        this.canvas.removeEventListener("pointercancel", this._handler);
        this.canvas.removeEventListener("pointerleave", this._handler);
        this._started = false;
    }
}
